(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__modern"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["some-image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.{{ section.settings.slider_class }}__slides');
  let currentIndex = 0;

  function showSlide(index) {
    const totalSlides = slider.children.length;
    const offset = index * -100;
    slider.style.transform = `translateX(${offset}%)`;
  }

  // Auto-slide functionality
  setInterval(function() {
    currentIndex = (currentIndex + 1) % slider.children.length;
    showSlide(currentIndex);
  }, 5000); // Adjust the timing as needed
});

  } catch(e) { console.error(e); }
})();
})();
